<template>
  <div v-parallax-fit="parallax" class="painting" ref="painting2" id="painting-2">
    <img src="/themes/rise-theme/dist/images/estate/character-view/holly/03_Book02.png" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 0,
          end: 400,
          fromStyle: { transform: 'translateX(-60%) translateY(-40%)', opacity: 0 },
          toStyle: { transform: 'translateX(-60%) translateY(-40%)', opacity: 1 },
          easing: 'linear'
        },
        {
          start: 800,
          end: 1200,
          fromStyle: { transform: 'translateX(-60%) translateY(-40%) rotateZ(-35deg)' },
          toStyle: { transform: 'translateX(-185%) translateY(-15%) rotateZ(-35deg)' },
          easing: 'linear'
        },
        {
          start: 1200,
          end: 1800,
          fromStyle: { transform: 'translateX(-170%) translateY(-15%) rotateZ(-35deg)', },
          toStyle: { transform: 'translateX(-350%) translateY(-150%) rotateZ(-35deg)',  },
          easing: 'linear'
        },
        {
          start: 1800,
          end: 2200,
          fromStyle: { transform: 'translateX(-350%) translateY(-150%) rotateZ(-35deg)', opacity: 1, },
          toStyle: { transform: 'translateX(-420%) translateY(-200%) rotateZ(-35deg)', opacity: 0.5, marginTop: '10px' },
          easing: 'linear'
        },
        {
          start: 2200,
          end: 2600,
          fromStyle: { transform: 'translateX(-420%) translateY(-200%) rotateZ(-35deg)', opacity: 0.5, },
          toStyle: { transform: 'translateX(-550%) translateY(-300%) rotateZ(-35deg)', opacity: 0 },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.marginTop == '10px') {
          self.$evidence.value = null;
          self.$readMore.value = '';
        }
      });
    });

    this.mutationObserver.observe(this.$refs.painting2, {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  }
}
</script>

<style lang="scss" scoped>
.painting {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  max-width: 200px;
  transition: all 0.1s linear;
}

@media screen and (max-width: 1024px) {
  .painting {
    max-width: 120px;
  }
}

@media screen and (max-width: 650px) {
  .painting {
    max-width: 75px;
  }
}
</style>
